import React , { useRef } from "react";
import './Contact.css';
import emailjs from '@emailjs/browser';
import { useState, useContext } from "react";
import { themeContext } from "../../Context";
import {motion} from 'framer-motion';
import { useTranslation } from "react-i18next"; //translator


/* const {
    REACT_APP_YOUR_SERVICE_ID, REACT_APP_YOUR_TEMPLATE_ID, REACT_APP_YOUR_PUBLIC_KEY,
} = process.env; */


const Contact = () => {
   const[t] = useTranslation("global");

        //---------------------------------------------

        function validate(input){
        
            //let en1= t("Contact.er.name.1")
            let errors = {};

            if(!input.user_name) { errors.user_name = t("Contact.er.name.1")}
            if(input.user_name.length > 100) { errors.user_name =  t("Contact.er.name.2")}
            if (!/^[a-zA-Z\s]+$/.test(input.user_name)) {errors.user_name =  t("Contact.er.name.3") }
            
            //---------------------------------  
            if(!input.user_email) { errors.user_email= t("Contact.er.name.1")}
            if ( !/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i.test(input.user_email)) {errors.user_email = t("Contact.er.email")}
            //---------------------------------
            if(!input.message){errors.message = t("Contact.er.name.1")}
            if(input.message.length <= 50){errors.message = t("Contact.er.msg")} 
            //---------------------------------
        
            

            return errors;
        };


        //-----------------------------------------------




    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    const form = useRef();

    const[done, setDone] = useState(false);
    const [errors, setErrors] = useState({
        user_name : t("Contact.er.name.1"),
    });

    const[input, setInput] = useState({
        user_name : "",
        user_email : "",
        message : "",
       
    });


    //----------------------------------------
            function handleChange(e){
                setInput({
                    ...input,
                    [e.target.name] : e.target.value
                })

                setErrors(validate({
                    ...input,
                    [e.target.name] : e.target.value
                }))
                console.log(input)
            }
    //-------------------------------------


    const sendEmail = (e) => {
      e.preventDefault(); 
                                                                                    
      emailjs.sendForm("service_uwfxk9n", "template_q9uiswi", form.current, "3Rjj9ksxtr-YJVQpY")
      //emailjs.sendForm(`${process.env.REACT_APP_YOUR_SERVICE_ID}, ${process.env.REACT_APP_YOUR_TEMPLATE_ID}, ${form.current}, ${process.env.REACT_APP_YOUR_PUBLIC_KEY}`)
      //emailjs.sendForm(REACT_APP_YOUR_SERVICE_ID,REACT_APP_YOUR_TEMPLATE_ID, form.current, REACT_APP_YOUR_PUBLIC_KEY)
       //emailjs.sendForm(process.env.REACT_APP_YOUR_SERVICE_ID, process.env.REACT_APP_YOUR_TEMPLATE_ID, form.current, process.env.REACT_APP_YOUR_PUBLIC_KEY)
        .then((result) => {
            console.log(result.text);

            setDone(true);

            setInput({
                user_name: "",
                user_email: "",
                message: "",
              });

            form.reset();
           // window.location.reload();
        }, (error) => {
            console.log(error.text);
        });
    };

    return(
       <div className="contact-form" id="Contact">
                 
            <div className="awesome tc">{/*  left side */}
            
                <span></span>
                <span style={{color : darkMode? 'white' : ''}}>{t("Contact.title.1")}</span>
                <span>{t("Contact.title.2")}</span>
                <div className="blur" style={{backgroundColor:"rgb(238 210 255)"}} ></div>
            
            </div>


            <div className="c-right">{/*  right side */}
                <form ref={form} onSubmit={sendEmail}>

                    <input  type="text" name="user_name" className="user" value={input.user_name}  onChange={handleChange}  placeholder="Name"/>
                     {errors.user_name && (<p className="msg" style={{color : 'red'}}>{errors.user_name}</p>)}

                    <input type="email" name="user_email" className="user" value={input.user_email}  onChange={handleChange} placeholder="Email"/>
                     {errors.user_email && (<p className="msg"  style={{color : 'red'}}>{errors.user_email}</p>)}

                    <textarea name="message" className="user"  value={input.message}  onChange={handleChange} placeholder="Message"/>
                    {errors.message && (<p className="msg"  style={{color : 'red'}}>{errors.message}</p>)}

                    <button className="button"  type="submit" value="Send" 
                      disabled={Object.keys(errors).length === 0 ? false : true}
                     >
                       {t("Contact.btn")}
                    </button>

                    {/* <input type="submit" value="Send" className="button"/> */}
                    
                    <span className="msg"  style={{color : 'green'}}>{done && "Thank you for your message!"}</span> 

                    <motion.div
                     initial={{scale:0.2}}
                     whileInView={{ scale: 3 }}
                     transition={{ repeat: 2, duration: 2 }}
                        className="blur c-blur1"
                        style={{ background: "var(--purple)" }}
                    ></motion.div>

                </form>


            </div>
   
         </div> /* close */
    );
};

export default Contact;